import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils.ts";

import { renewTypeSchema } from "./PatientRenewalInfoModel";

const renewalNudgeWithType = cz.camelCaseObject({
  should_nudge: z.literal(true),
  last_cp_end: cz.optional(z.string()),
  renewal_type: renewTypeSchema,
});

const renewalNudgeWithoutType = cz.camelCaseObject({
  should_nudge: z.literal(false),
  last_cp_end: cz.optional(z.string()),
  renewal_type: cz.optional(z.never()),
});

export const renewalNudgeSchema = z.discriminatedUnion("should_nudge", [renewalNudgeWithType, renewalNudgeWithoutType]);

export type RenewalNudge = z.infer<typeof renewalNudgeSchema>;
